import { Routes, Route } from 'react-router-dom'

// Pages
import { 
  Home, 
  Classes, 
  ClassDetails, 
  About, 
  Gallery, 
  Contact, 
  Success, 
  Admin, 
  AdminLogin 
} from './pages'

// Components
import { Layout, ErrorBoundary, ScrollToTop } from './components'
import { BookingProvider } from './contexts/BookingContext'
import { AuthProvider } from './contexts/AuthContext'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BookingProvider>
          <ScrollToTop />
          <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/classes" element={<Classes />} />
                <Route path="/classes/:id" element={<ClassDetails />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/success" element={<Success />} />
                <Route path="/admin-login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
          </Layout>
        </BookingProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
